<script>
import lazyLoadComponent from '@router/lazyload-component'

import Layout from '@layouts/main'

export default {
  page: {
    title: '數據分析',
    meta: [
      { name: 'description', container: 'Data Analytics' },
      {
        name: 'google-signin-scope',
        content: 'https://www.googleapis.com/auth/analytics.readonly',
      },
    ],
  },
  components: {
    Layout
  },
  props: {
    staffItems: {
      type: Array,
      required: true,
    },
    merchantProducts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeTab: '1',
      formattedJson: '',
      tabList: [
        {
          title: '美容服務預約',
          component: () => lazyLoadComponent(import('./components/checkInList.vue')),
          type: 'component',
          fetchType: 'cosmetic',
          isSpace: false,
          fetchTypes: ['cosmetic']
        }
      ],
      filterLocationList: [],
      locationValue: '',
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',
      cosmeticSettingData: {}
    }
  },
  watch: {
  },
  async mounted() {
    this.initModuleTab()
    await this.getService()
  },
  methods: {
    showOffOuterTab() {
      for (let i = 0, len = this.$refs.outerTabs.$children[0].$refs.tabs.length; i < len; i++) {
        this.$refs.outerTabs.$children[0].$refs.tabs[i].style.display = 'none'
      }
    },
    getProductList({ filterLocationList }) {
      this.filterLocationList = filterLocationList
    },
    /**
     * @description 更動服務地點 -> 重新撈資料
     */
    changeLocation() {
      this.$refs.step1[0].updateFilterFromFather(this.locationValue)
    },
    resetProduct() {
      this.locationValue = ''
    },
    /**
     * @description 初始化module
     */
     initModuleTab() {
      if (this.$hasDayCare()) {
        this.tabList.push(
          {
            title: '安親住宿預約',
            component: () => lazyLoadComponent(import('./components/checkInList.vue')),
            type: 'component',
            fetchType: 'daycare',
            fetchTypes: ['daycare']
          }
        )
      }
      if(this.$hasSpaceModule()){
        this.tabList.push({
          title: '空間管理',
          component: () => lazyLoadComponent(import('./components/checkInList.vue')),
          type: 'component',
          fetchType: 'cosmetic',
          isSpace: true,
          fetchTypes: ['space']
        })
      }
    },
    async getService() {
      const { response } = await this.$store.dispatch(
        'merchant/getCosmeticBasicSet',
        {
          "type": "cosmetic",
        }
      )
      this.cosmeticSettingData = response.items
    }
  },
}
</script>

<template>
  <Layout>
    <div :class="$style.page">
      <el-tabs ref="outerTabs" v-model="activeTab" stretch type="border-card" class="isStyleBase"
        :class="$style.showTabPane">
        <el-tab-pane>
          <el-select v-model="locationValue" slot="label" :class="[$style.productPlacement]"
            class="is-no-tb-border is-r-border" placeholder="請選擇服務地點" style="color: white;" @change="changeLocation">
            <el-option v-for="(location, typeValue) in filterLocationList" :key="typeValue" :label="location.title"
              :value="location.id"></el-option>
          </el-select>
        </el-tab-pane>
        <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index + 1}`">
        </el-tab-pane>
      </el-tabs>
      <div v-for="(tab, index) in tabList" :key="index" :class="$style.componentMargin">
        <component :is="tab.component" v-if="Number(activeTab) === index + 1" :ref="`step${index + 1}`"
          :merchant-products="merchantProducts" :staff-items="staffItems" :fetch-type="tab.fetchType" :fetch-types="tab.fetchTypes" :is-space="tab.isSpace" :enable-admin-space-order="cosmeticSettingData.enableAdminSpaceOrder" :select-product-id="locationValue"
          @getProductList="getProductList" @reset="resetProduct">
        </component>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

:global {
  .isPage {
    .el-tabs__content {
      padding-bottom: 40px;
    }
  }
}

.page {
  :global {
    .el-tab-pane {
      background-color: $color-body-bg !important;
      padding: 20px;
    }

    .el-tabs__item {
      min-width: 152px;
    }
  }
}

.productPlacement {
  position: absolute;
  z-index: 100;
  left: 0;

  :global {
    .el-input__inner {
      height: $tabs-item--header-height;
      border-radius: 0;
      border: 0;
      color: white;
      font-size: 16px;

      &::placeholder {
        color: white;
        opacity: 1;
      }
    }

    .el-input__icon {
      color: white;
    }
  }

  @include pad {
    top: 0;
  }

}

:global {
  .is-r-border>.el-input>.el-input__inner {
    background-color: $color-primary;
    text-align: center;
    color: white;
  }

  .is-r-border>.el-input {
    :global {
      .el-input__icon {
        color: white;
      }
    }
  }

  .el-select-dropdown__list {
    padding-top: 9px;
    padding-bottom: 9px;
  }

  .el-select-dropdown {
    border-radius: $border-radius;
  }
}

.showTabPane {
  :global {
    .el-tabs__content {
      display: none;
    }
  }
}

.componentMargin {
  margin: 20px;
}
</style>
  